import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import "./Manualxx.css";

/**
 * Manual Genio dentro del Visor, igual que el Manual CIMA dentro de CIMA: lo abre
 * cualquier usuario desde el menu de su foto, sin permisos aparte. El manual es un
 * solo archivo versionado con el front (public/manual/manual-genio.html) y sus
 * capturas (public/manual/capturas), asi cada despliegue trae la version vigente.
 * Se pinta en un marco aislado para que su hoja de estilos no toque la del Visor.
 */
const BASE = `${process.env.PUBLIC_URL ?? ""}/manual`;
const RUTA = `${BASE}/manual-genio.html`;

// El marco usa srcDoc y en srcDoc las rutas se resuelven contra la pagina del Visor
// (/home/...): las capturas se vuelven absolutas a /manual/capturas, y los enlaces
// del indice (#capitulo) se resuelven aqui con un desplazamiento, porque si no el
// marco navegaria a /home#capitulo y cargaria el Visor dentro del manual.
const SALTOS = `<script>document.addEventListener("click",function(e){var a=e.target.closest('a[href^="#"]');if(!a)return;var d=document.getElementById(a.getAttribute("href").slice(1));if(!d)return;e.preventDefault();d.scrollIntoView({behavior:"smooth",block:"start"});});</script>`;

const documentoDe = (contenido) =>
  `<!doctype html><html lang="es" data-theme="light"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"></head><body>${contenido.replaceAll(
    'src="capturas/',
    `src="${BASE}/capturas/`
  )}${SALTOS}</body></html>`;

const Manualxx = ({ show, onClose }) => {
  const [contenido, setContenido] = useState("");
  const [fallo, setFallo] = useState(false);

  useEffect(() => {
    if (!show || contenido !== "") return undefined;
    let vigente = true;
    setFallo(false);
    fetch(RUTA, { cache: "no-cache" })
      .then((respuesta) => (respuesta.ok ? respuesta.text() : Promise.reject(new Error(String(respuesta.status)))))
      .then((texto) => vigente && setContenido(texto))
      .catch(() => vigente && setFallo(true));
    return () => {
      vigente = false;
    };
  }, [show, contenido]);

  return (
    <Modal size="xl" show={show} onHide={onClose} dialogClassName="manualxx-dialogo">
      <Modal.Header style={{ backgroundColor: "#000000", color: "white" }}>
        MANUAL GENIO
        <Button className="btn-close btn-close-white" aria-label="Cerrar" onClick={onClose} />
      </Modal.Header>
      <Modal.Body className="manualxx-cuerpo">
        {fallo && <div className="manualxx-estado">No se pudo abrir el manual. Cierra la ventana e intenta de nuevo.</div>}
        {!fallo && contenido === "" && <div className="manualxx-estado">Cargando el manual…</div>}
        {contenido !== "" && (
          <iframe className="manualxx-marco" title="Manual Genio" sandbox="allow-scripts" srcDoc={documentoDe(contenido)} />
        )}
      </Modal.Body>
    </Modal>
  );
};

export default Manualxx;
